import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OskSubscriptionsComponent } from './osk-subscriptions.component';
import { FasServiceDynamicTableComponent } from 'fas-services';
import { TabViewModule } from 'primeng/tabview';
import { OskAvailableSubscriptionsListComponent } from './osk-available-subscriptions-list/osk-available-subscriptions-list.component';
import { OskHistorySubscriptionsListComponent } from './osk-history-subscriptions-list/osk-history-subscriptions-list.component';
import { ButtonModule } from 'primeng/button';
import { OskBuySubscriptionFormComponent } from './osk-buy-subscription-form/osk-buy-subscription-form.component';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { OskPaymentCancelComponent } from './osk-payment-cancel/osk-payment-cancel.component';
import { OskPaymentSuccessComponent } from './osk-payment-success/osk-payment-success.component';
import { OskSubscriptionListComponent } from './osk-subscription-list/osk-subscription-list.component';
import { SubscriptionTagComponent } from '../../shared/components/subscription-tag/subscription-tag.component';


@NgModule({
  declarations: [
    OskSubscriptionsComponent,
    OskAvailableSubscriptionsListComponent,
    OskHistorySubscriptionsListComponent,
    OskBuySubscriptionFormComponent,
    OskSubscriptionListComponent,
    OskPaymentSuccessComponent,
    OskPaymentCancelComponent,
  ],
  imports: [
    CommonModule,
    RouterOutlet,
    TabViewModule,
    FasServiceDynamicTableComponent,
    ButtonModule,
    TagModule,
    TableModule,
    InputNumberModule,
    FormsModule,
    SubscriptionTagComponent
  ]
})
export class OskSubscriptionsModule {}
